<template>
  <div />
</template>

<script>
import ConfigurationHelper from '@/helpers/ConfigurationHelper'

export default {
  async mounted() {
    const configurationCode = this.$route.query.configuratie || this.$route.query.code

    const cartId = this.$route.query.encryptedCartId

    // new configuration
    const configRoute = ConfigurationHelper.generateConfigurationRoute(
      this.$route.params,
      this.$route.query,
      configurationCode,
      cartId
    )

    let pageName = cartId
      ? 'new-shopping-cart-page'
      : configurationCode
        ? `new-configuration-page`
        : 'new-configuration-page-no-config'

    this.$router.push({
      name: pageName,
      params: configRoute.params,
      query: configRoute.query,
    })
  },
}
</script>

<style></style>
